import type { LogEntry, LogQuery, LogQueryResult } from "@skaile/workspaces/types";
import { type LogSink, LogStoreDisabledError } from "./types.js";

export class NoOpSink implements LogSink {
  write(_entry: LogEntry): void {}
  writeBatch(_entries: LogEntry[]): void {}
  query(_q: LogQuery): LogQueryResult {
    throw new LogStoreDisabledError();
  }
  close(): void {}
}
